import { useState, useEffect } from "react";

import { civilStatesList, genderList } from "../../../API/Employee/Profile";
import { getCandidateInfo, putCandidateInfo } from "../../../API/Candidates/Cadidate";
import { patchCandidatePresentation } from "../../../API/Candidates/Presentation";
import { Address } from "./Components/Address";
import { Family } from "./Components/Family";
import { Health } from "./Components/Health";
import { Personal } from "./Components/Personal";
import { SocialNetwork } from "./Components/SocialNetwork";
import { MenuForm } from "./Components/MenuForm/MenuForm";
import { getCountry } from "../../../API/Lists/country";
import Loading from "../../../Components/Loading/Loading";
import UploadService from "../../../API/Upload/UploadService";

import "./profile.sass";
import Swal from "sweetalert2";

const REGEXRulePNG = /(documents\/candidates\/).*(.png)/g;
const REGEXRuleJPG = /(documents\/candidates\/).*(.jpg)/g;
const REGEXRuleJPEG = /(documents\/candidates\/).*(.jpeg)/g;

const regexSpace = /(%20)/g;

const ProfileEdit = () => {
  const { id } = JSON.parse(localStorage.getItem("user"));

  const profileEmpty = {
    name: "",
    mail: "",
    phone: "",
    address: "",
    city: "",
    nationality: "",
    birth: "",
    family_composition: "",
    person_with_disability: "",
    country: "",
    gender: undefined,
    national_identification_number: undefined,
    civil_status: undefined,
    profile_image: undefined,
    image: undefined,
    pcdResp: false,
    facebook: "",
    instagram: "",
    linkedin: "",
  };

  const [loading, setLoading] = useState(false);

  const [lists, setLists] = useState({
    gender: [],
    maritalStatus: [],
    country: [],
  });

  const [data, setData] = useState(profileEmpty);
  const [dataImage, setDataImage] = useState(null);

  const [error, setError] = useState({
    mail: false,
    phone: false,
    national_identification_number: false,
    birth: false,
    gender: false,
    city: false,
    country: false,
  });

  useEffect(() => {
    const fetchList = async () => {
      const [country, gender, maritalStatus] = await Promise.all([getCountry(), genderList(), civilStatesList()]);

      setLists({
        country,
        gender,
        maritalStatus,
      });
    };

    const fetchData = async () => {
      setLoading(true);
      const { item } = await getCandidateInfo(localStorage.getItem("candidateId"));

      if (item) {
        const date = item?.birth?.split("-").reverse().join("-");
        setData({
          name: item?.name,
          mail: item?.mail,
          phone: item?.phone,
          address: item?.address,
          city: item?.city,
          country: item?.country_id,
          nationality: item?.nationality,
          national_identification_number: item?.national_identification_number,
          gender: item?.gender_id,
          birth: date,
          civil_status: item?.civil_status_id,
          family_composition: item?.family_composition,
          profile_image: item?.image,
          image: item.image,
          pcdResp: !item.person_with_disability ? false : true,
          person_with_disability: item.person_with_disability,
          facebook: item?.network?.facebook,
          instagram: item?.network?.instagram,
          linkedin: item?.network?.linkedin,
        });
      }
      setLoading(false);
    };

    fetchData();
    fetchList();
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = name === "gender" || name === "civil_status" ? Number(event.target.value) : event.target.value;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleImage = (image) => {
    setData({
      ...data,
      profile_image: image,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);

    if (dataImage) {
      const hash = localStorage.getItem("hash");
      const id = localStorage.getItem("candidateId");

      const { url } = await UploadService.getAuthorizationUploadImageFile(dataImage?.originalName, hash, id);

      UploadService.UploadFile(url, data?.profile_image, "image");
      setLoading(false);
    }

    const regexAuxPNG = data?.image?.match(REGEXRulePNG);
    const regexAuxJPG = data?.image?.match(REGEXRuleJPG);
    const regexAuxJPEG = data?.image?.match(REGEXRuleJPEG);

    const profile = {
      //Person
      name: data.name,
      mail: data.mail,
      phone: data.phone,
      national_identification: data.national_identification_number,
      birth: data.birth?.split("-").reverse().join("-") || null,

      //Family
      gender: data.gender,
      civil_status: data.civil_status,
      family_composition: data.family_composition,

      //Address
      city: data.city,
      country: data.country,
      address: data.address,
      nationality: data.nationality,

      //Helth
      person_with_disability: JSON.parse(data.pcdResp) ? data.person_with_disability : null,

      //Network
      profile_image: dataImage
        ? `documents/candidates/${id}/profile-image/${dataImage.originalName}`
        : regexAuxPNG
        ? regexAuxPNG[0].replace(regexSpace, " ")
        : regexAuxJPG
        ? regexAuxJPG[0].replace(regexSpace, " ")
        : regexAuxJPEG
        ? regexAuxJPEG[0].replace(regexSpace, " ")
        : null,
    };
    const network = {
      facebook: data.facebook,
      linkedin: data.linkedin,
      instagram: data.instagram,
    };
    const resp = await putCandidateInfo(profile, id);

    if (resp.items === "Updated candidate") {
      Swal.fire({
        title: "El envío se ha efectuado con exito!",
        text: "",
        icon: "success",
        showCancelButton: false,
        showConfirmButton: true,
      });
    } else {
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
    await patchCandidatePresentation(network, id);
    setLoading(false);
  };

  return (
    <>
      {loading && (
        <div className="loading">
          <Loading />
        </div>
      )}

      <div className="content-profile-edit">
        <div className="menu">
          <MenuForm />
        </div>
        <div className="w-100">
          <div className="form">
            <div className="row">
              <div className="col">
                <div className="box" id="personal">
                  <Personal onChange={handleChange} data={data} error={error} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="box" id="socialNetwork">
                  <SocialNetwork data={data} handleImage={handleImage} setDataImage={setDataImage} onChange={handleChange} error={error} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="box" id="family">
                  <Family onChange={handleChange} data={data} error={error} lists={lists} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="box" id="address">
                  <Address onChange={handleChange} data={data} error={error} lists={lists} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="box" id="health">
                  <Health onChange={handleChange} data={data} />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col d-flex justify-content-end">
              <button onClick={() => handleSubmit()}>Guardar</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProfileEdit;
